const BackupGuidanceBox = () => {
  return (
    <div className="mb-[18px] flex gap-2 rounded-xl border border-[#C9DEDA] bg-[#EAF1F0] px-3.5 py-3 text-[12.5px] leading-8 text-[#4A5568]">
      فایل پشتیبان در قالب اکسل با چندین شیت (به‌ازای هر بخش) ساخته می‌شود.
      داده‌ها به‌صورت کاملاً ساختاریافته و قابل جست‌وجو ذخیره می‌شوند. این امکان
      روزی یک‌ بار در دسترس است.
    </div>
  );
};

export default BackupGuidanceBox;
